module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logAll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "logArea"
  }, [_c('ul', {
    staticClass: "noListStyle"
  }, _vm._l((_vm.logs.slice().reverse()), function(log) {
    return _c('li', [_vm._v(_vm._s(log))])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('strong', [_vm._v("Bus Data Stream:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e3cef8b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logAllComponent.vue
// module id = 80
// module chunks = 1